import axios from 'axios'
import { Auth } from '@/networks/api'
import { localStorage } from '@/util/storage'
import { login } from '@/util/user'
import types from './types'

class UserInfo {
  constructor({
    token = null,
    expiryTime = null,
    isLogin = false,
    userInfo = null
  } = {}) {
    this.token = token
    this.expiryTime = expiryTime
    this.isLogin = isLogin
    this.userInfo = userInfo
  }
}

export default {
  state() {
    return new UserInfo()
  },
  mutations: {
    [types.SET_USERINFO](state, { body, exp }) {
      state.token = body
      state.expiryTime = exp
      state.isLogin = true
      axios.defaults.headers.common['Authorization'] = `Bearer ${body}`
      localStorage.setItem('userInfo', state)
    },
    // 主动退出登录
    [types.LOGOUT](state) {
      state.token = null
      state.expiryTime = null
      state.isLogin = false
      localStorage.removeItem('userInfo')
      localStorage.removeItem('UserPersonalInformation')
    },
    [types.SET_USERINFO_MOUNTED](state, { token, expiryTime, isLogin }) {
      state.token = token
      state.expiryTime = expiryTime
      state.isLogin = isLogin
      axios.defaults.headers.common['Authorization'] = `Bearer ${state.token}`
      localStorage.setItem('userInfo', state)
    },
    [types.SET_USER_INFO](state, payload) {
      state.userInfo = payload
      localStorage.setItem('UserPersonalInformation', payload)
    }
  },
  actions: {
    async [types.GET_TOKEN]({ dispatch, commit, rootState }) {
      const handleError = () => {
        localStorage.removeItem('userInfo')
        login()
      }
      try {
        const result = await Auth.getToken({ rootState })
        const { status } = result
        // 用户未登录 status === 9 等价于老接口的401状态
        if(Number(status) === 9){
          handleError()
        } else {
          commit(types.SET_USERINFO, result)
        }
      } catch (e) {
        console.log('APIERROR====GET_TOKEN err=====', e)
        // const response = e.response
        // const status = response && response.status
        // // 401接口已经统一改为 status 9
        // if (status === 401) {
        //   handleError()
        // }
      }
    },
    async [types.GET_USER_INFO]({ commit, state, rootState }) {
      // if (state.userInfo) return
      try {
        const { data } = await Auth.getUserInfo({ rootState })
        // console.log('====GET_USER_INFO====', data)
        commit(types.SET_USER_INFO, data)
      } catch (error) {
        console.log('APIERROR===GET_USER_INFO===', error)
        commit(types.SET_USER_INFO, null)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js